module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "zoom-out",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "love-map"
  }, [_c('transition-group', {
    attrs: {
      "name": "zoom-in",
      "appear": ""
    }
  }, _vm._l((_vm.school), function(name) {
    return _c('div', {
      key: name,
      staticClass: "point",
      class: {
        highlight: name === _vm.current
      },
      style: (_vm.getPosition(_vm.schoolList[name]))
    })
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/template-compiler?{"id":"data-v-70b531d1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/Users/Mee/Work/lls-with-tfchina/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoveMap.vue
// module id = 206
// module chunks = 0